import settings from '@solinkcorp/settings';
import { useEffect, useState } from 'react';
import { type OutageIndicator } from './outageStatus';

export interface OutageStatus {
  page: { id: string; name: string; url: string; time_zone: string; updated_at: string };
  status: { indicator: OutageIndicator; description: string };
}

/**
 * Returns the current outage status from Statuspage, or `undefined` while loading / on fetch failure.
 */
export function useOutageStatus(): OutageStatus | undefined {
  const [outageStatus, setOutageStatus] = useState<OutageStatus | undefined>();

  useEffect(() => {
    fetchStatus().then(setOutageStatus, (err) => console.error(`Error fetching status`, err));
  }, []);

  return outageStatus;
}

async function fetchStatus(): Promise<OutageStatus> {
  const status = await fetch(settings.status_url, { cache: 'no-store' });
  const statusJson = await status.json();
  return statusJson as OutageStatus;
}
